// extracted by mini-css-extract-plugin
export default {"container":"container___Doevr","container_tabs":"container_tabs___EOb2I","container_tabs_active":"container_tabs_active___Qj96j"};